var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGreenHeart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 98,
    viewBox: "0 0 120 98",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M60.531 25.2669C60.531 25.2669 81.797 -13.7982 107.419 5.22037C152.257 38.3743 62.8369 98 62.8369 98C62.8369 98 -35.5504 43.2575 13.8995 6.5054C41.8271 -14.3122 60.531 25.2669 60.531 25.2669Z",
    fill: "#27AE60"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.5 43L60.3 58.0008L85.8 32.5",
    stroke: "#FCFCFD",
    strokeWidth: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGreenHeart);
export default __webpack_public_path__ + "static/media/green-heart.6d089f19001d4a865baa5ff10a90def6.svg";
export { ForwardRef as ReactComponent };